import { YANDEX_METRICS_IDS } from '../consts.js';

/**
 * Parse cookie
 * @param {string} value - cookie string
 * @param {string} separator
 * @returns {Object}
 */
const parseCookie = (value, separator) => {
    if (!value) {
        return {};
    }
    const decodedValue = decodeURIComponent(value);
    return decodedValue.split(separator).reduce((acc, cur) => {
        const [key, value] = cur.split('=');
        acc[key] = /^\s/.test(value) || !value ? undefined : value;
        return acc;
    }, {});
};
const parseUTMCookie = (value) => parseCookie(value, '|');
const parsePartnerCookie = (value) => parseCookie(value, '&');
const parsePromotionCookie = (value) => parseCookie(value, '|');
const minifyString = (string) => string.replace(/(\r\n|\n|\r|\\n)/gm, '').replace(/\s\s+/g, ' ');
const getGtmCode = (code) => `(function(w,d,s,l,i){w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.defer=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','${code}');`;
/**
 * @deprecated
 */
const defineABVariant = (name = '', dataLayer = 'dataLayer') => minifyString(`(function(w,d,l,c){
  var m = d.cookie.match(RegExp('(?:^|;\\\\s*)'+c+'=([^;]*)'));
  var v=m?m[1]:null;v && w[l].push({ABvariant: v});
  })(window,document,'${dataLayer}','${name}');`);
const defineGoogleClientId = (dataLayer = 'dataLayer') => minifyString(`(function(w,d,l,c,ga){
    var m = d.cookie.match(RegExp('(?:^|;\\\\s*)'+c+'=([^;]*)'));
    var cookieValue=m?m[1]:undefined;
    if (typeof cookieValue !== 'undefined') { 
        var clientId = cookieValue.split('.').slice(-2).join('.');
        w[l].push({GoogleClientID: clientId});
        return;
    }
    if (typeof w[ga] !== 'undefined' && typeof w[ga].getAll === 'function') { 
        var tracker = w[ga].getAll()[0];
        var clientId = tracker.get('clientId');
        w[l].push({GoogleClientID: clientId});
        return;
    }
    })(window,document,'${dataLayer}','_ga', 'ga');`);
const getYandexMetricsCode = (params) => {
    const { id, webvisor, childIframe, defer } = params;
    return minifyString(`(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
    m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
    (window, document, "script", "https://mc.yandex.ru/metrika/" + (window.sravni_tag_manager.get('isTurboApp') ? "tag_turboapp.js" : "tag.js") , "ym");

     (function(w,d){

        ym(${id}, "init", {
            childIframe: ${childIframe || false},
            defer: ${defer || false},
            triggerEvent: true,
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true,
            webvisor:${webvisor || false},
            trackHash:true,
            ecommerce:"dataLayer",
            userParams:{
                "analyticsId": w.sravni_tag_manager.get('analyticsId'),
                 "UserID": w.sravni_tag_manager.get('SravniUserId'),
                 "GoogleClientID": w.sravni_tag_manager.get('GoogleClientID')
             },
            params:{
                "theme": w.sravni_tag_manager.get('theme'),
                "UserID": w.sravni_tag_manager.get('SravniUserId'),
                "abTestingStatistics": w.sravni_tag_manager.get('abTestingStatistics'),
                "analyticsId": w.sravni_tag_manager.get('analyticsId'),
             }
       });

     })
     (window, document);
`);
};
const defineIsTurboApp = (dataLayer) => minifyString(`(function(w,d,l){
    var isTurboApp = typeof window !== 'undefined' && typeof window.navigator !== 'undefined' && window.navigator.userAgent.indexOf('TA/') !== -1;
    w[l].push({isTurboApp: isTurboApp});
    })(window,document, '${dataLayer}');`);
const getYandexMetricsId = (isWhiteLabel) => {
    if (isWhiteLabel)
        return YANDEX_METRICS_IDS.WHITELABEL;
    return YANDEX_METRICS_IDS.COMMON;
};
const getGtmOptionsFromSravniTMOptions = (options) => {
    const { googleTmId, userId, theme, abTestingStatistics, ab, wl, isWebview, fullURL, push } = options;
    return {
        id: googleTmId,
        ...(userId ? { userId } : {}),
        ...(theme ? { theme } : {}),
        ...(ab ? { ab } : {}),
        ...(abTestingStatistics ? { abTestingStatistics } : {}),
        ...(wl ? { wl } : {}),
        ...(fullURL ? { fullURL } : {}),
        ...(typeof isWebview === 'boolean' ? { isWebview } : {}),
        ...(push ? { push } : {}),
    };
};
const getYandexMetricsOptionsFromSravniTMOptions = (options) => {
    const { yandexMetricsId: deprecatedMetricsId, userId, theme, abTestingStatistics, ab, wl, isWebview, push, webvisor: deprecatedWebvisor, yandexMetricsOptions: { id: metricsId, webvisor: yandexWebvisor, childIframe, defer } = {}, } = options;
    const webvisor = yandexWebvisor || deprecatedWebvisor;
    const yandexMetricsId = metricsId || deprecatedMetricsId;
    const isWhiteLabel = typeof wl !== 'undefined';
    // eslint-disable-next-line no-unneeded-ternary
    const id = yandexMetricsId ? yandexMetricsId : getYandexMetricsId(isWhiteLabel);
    return {
        id,
        ...(userId ? { userId } : {}),
        ...(theme ? { theme } : {}),
        ...(ab ? { ab } : {}),
        ...(abTestingStatistics ? { abTestingStatistics } : {}),
        ...(wl ? { wl } : {}),
        ...(typeof isWebview === 'boolean' ? { isWebview } : {}),
        ...(push ? { push } : {}),
        ...(typeof webvisor === 'boolean' ? { webvisor } : {}),
        ...(typeof childIframe === 'boolean' ? { childIframe } : {}),
        ...(typeof defer === 'boolean' ? { defer } : {}),
    };
};
const defineSravniTM = (options) => {
    const { dataLayer, googleDataLayer, yandexId } = options;
    const response = [
        `(function(w,d,l,gl){
      var googleDataLayer = w[gl];
      var availableEvents = ['mainEvent', 'adEvent', 'pageViewGA'];
      var yaCounterRetries = 3;
      var ymCallWithRetry = function() {
        var isYandexMetricInit = typeof w['yaCounter${yandexId}'] !== 'undefined';

        if (isYandexMetricInit) {
          w.ym.apply(w.ym, [${yandexId}].concat([].slice.call(arguments, 0)) );
          yaCounterRetries = 3;
          } else {
            if (yaCounterRetries !== 0) {
              w.setTimeout(function() {
                yaCounterRetries -= 1;
                ymCallWithRetry.apply(this, arguments);
              }, 200);
            }
          }
      };

      function TagManager () {};
      TagManager.prototype.get = function(key) { 
          var dataObject = w[l].reduce(function(acc, data){ return Object.assign(acc, data) }, {});
          return dataObject[key];
      };
      TagManager.prototype.emitEvents = function(events) {
        for (var i = 0; i < events.length; i++) {
          this.emitEvent(events[i])
        }
      };
      TagManager.prototype.emitEvent = function(event) {
        this.emitYandexEvent(event);
      };
      TagManager.prototype.emitYandexEvent = function(event) {
        var eventType = event.event;
        switch (eventType) {
          case 'pageViewGA':
            return this.emitYandexHitEvent(event);
          case 'mainEvent':
          case 'adEvent':
            return this.emitYandexReachGoalEvent(event);
        }
      };
      TagManager.prototype.emitYandexHitEvent = function(event) {
        var path = event.path;
        var title = event.title;

        ymCallWithRetry('hit', path, {
          title: title,
          referer: d.referrer || '',
          params:{
            "theme": this.get('theme'),
            "abTestingStatistics": this.get('abTestingStatistics'),
            "analyticsId": this.get('analyticsId'),
          }
        });
      };
      TagManager.prototype.emitYandexReachGoalEvent = function(event) {
        var createEventType = function(event) {
          var eventCategory = event.eventCategory || '';
          var eventAction = event.eventAction || '';
  
          var eventType = (eventCategory + '_' + eventAction).replace(/[\\s\\|]/g,"_");
          var adaptEventType = function(eventType) {
            var templates = ['Кредитные_карты_Платный_клик', 'Микрокредиты_Платный_клик', 'РКО_Платный_клик', 'Ипотека_Платный_клик', 'Вклады_Платный_клик', 'Дебетовые_карты_Платный_клик', 'Кредиты_Платный_клик'];
            var newEventType = templates.find(function(template) { return eventType.indexOf(template) === 0 });

            return newEventType ? newEventType : eventType;
          };

          return adaptEventType(eventType);
        };
        
        var goalEventType = createEventType(event);
        var eventCategory = event.eventCategory || '';
        var eventAction = event.eventAction || '';        
        var eventLabel = event.eventLabel;
        var eventValue = event.eventValue;
        var pagePath = event.path || w.location.pathname || '';
        var theme = this.get('theme');
        var abTestingStatistics = this.get('abTestingStatistics');
        var analyticsId = this.get('analyticsId');

        var goalParams = {
          eventCategory: eventCategory,
          eventAction: eventAction,
          eventLabel: eventLabel,
          eventPagePath: pagePath,
          eventCategoryAction: goalEventType,
          theme: theme,
          abTestingStatistics: abTestingStatistics,
          analyticsId: analyticsId,
        };

        if (eventValue) {
          goalParams.eventValue = eventValue;
          goalParams.order_price = eventValue;
          goalParams.currency = 'RUB';
        };
        
        ymCallWithRetry('reachGoal', goalEventType, goalParams);
      };
      TagManager.prototype.findEventsFromData = function(data, eventsForSearch) {
        return data.filter(function(element) { return element.hasOwnProperty('event') && eventsForSearch.indexOf(element.event) > -1; })
      };
      TagManager.prototype.findUserId = function(data) {
        var obj = data.find(function(element) {
            return element.hasOwnProperty('SravniUserId')
          });
        if (!obj) return undefined;
          
        return obj['SravniUserId']
    };
      TagManager.prototype.convertToTagManagers = function(data) {
        for (var i = 0; i < data.length; i++) {
          googleDataLayer.push(data[i])
        };

        var events = this.findEventsFromData(data, availableEvents);
        var userId = this.findUserId(data);

        if (events && events.length > 0) this.emitEvents(events);

        if (typeof userId !== 'undefined') ymCallWithRetry('setUserID', userId);
      };   
      w.sravni_tag_manager = new TagManager();
    })(window, document, '${dataLayer}', '${googleDataLayer}');`,
        `(function(w,d,l){
      var a = w[l];

      if (typeof a !== 'undefined' && a['push'].toString().indexOf('[native code]') === -1 ) return;
      
      if ("function" === typeof a.push) {
        w.sravni_tag_manager.convertToTagManagers(a);
       
        var b = a.push;
        a.push = function() {
            var a = b.apply(this, arguments);
            w.sravni_tag_manager.convertToTagManagers([].slice.call(arguments, 0));
            
            return a;
        }
    }
    })(window, document, '${dataLayer}');`,
    ];
    return minifyString(response.join(''));
};

export { defineABVariant, defineGoogleClientId, defineIsTurboApp, defineSravniTM, getGtmCode, getGtmOptionsFromSravniTMOptions, getYandexMetricsCode, getYandexMetricsId, getYandexMetricsOptionsFromSravniTMOptions, parseCookie, parsePartnerCookie, parsePromotionCookie, parseUTMCookie };
//# sourceMappingURL=index.js.map
